import { useTranslation } from 'react-i18next';
import { cn } from '@hero/web-lib';

export type FinancingFooterProps = {
  /** Optional disclosure override; defaults to `landing.footer.disclosure`. */
  disclosure?: string;
  className?: string;
};

/**
 * Disclosure line: "Hero is a network, not a lender — funding
 * decisions are made by partner institutions." Reused by the
 * carrier `/financing` dashboard, the public lender inbox, and
 * any standalone landing page.
 */
export function FinancingFooter({ disclosure, className }: FinancingFooterProps) {
  const { t } = useTranslation('m-financing');
  return (
    <footer
      className={cn(
        'rounded-2xl border border-gray-200 bg-gray-50/70 px-5 py-4 text-center text-xs leading-relaxed text-gray-600',
        className,
      )}>
      {disclosure ?? t('landing.footer.disclosure')}
    </footer>
  );
}
